// TODO: localize
export const text = {
    placeholder: `Enter or paste a link`,
    edit: `Edit`,
    save: `Save`,
    add: `Add Link`,
    remove: `Remove`,
};
